import "core-js/modules/es.regexp.constructor.js";
import "core-js/modules/es.regexp.dot-all.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.sticky.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.string.split.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'TheCookieNotification',
  data: function data() {
    return {
      type: 'compact',
      showCookieNotification: false
    };
  },
  mounted: function mounted() {
    // Check if cookies were accepted previously.
    if (!this.getCookie('cookiesAccepted')) {
      this.showCookieNotification = true;
    }
  },
  methods: {
    getCookie: function getCookie(name) {
      var pattern = RegExp(name + '=.[^;]*');
      var matched = document.cookie.match(pattern);

      if (matched) {
        var cookie = matched[0].split('=');
        return cookie[1];
      }

      return false;
    },
    acceptCookies: function acceptCookies() {
      this.showCookieNotification = false;
      this.$store.commit('setState', {
        key: 'cookiesAreAccepted',
        value: true
      });
      var daysToExpire = 365;
      document.cookie = "cookiesAccepted=true; max-age=".concat(daysToExpire * 60 * 60 * 1000, "; path=/;");
    }
  }
};